export default "__VITE_ASSET__396280fb__"